var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-forms" },
    [
      !_vm.isSent
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row form-group" }, [
                _c("div", { staticClass: "col-md-12 mbm" }, [
                  _vm._v(_vm._s(_vm.$t("form_complaint_introtext"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("label", { attrs: { for: "form", id: "form_label" } }, [
                    _vm._v(_vm._s(_vm.$t("form_topic"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-8" },
                  [
                    _c("IcSelect", {
                      attrs: {
                        id: "form",
                        values: _vm.formTypeComplaint,
                        allowEmpty: false,
                      },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.selectedComponent
                ? _c(_vm.selectedComponent, {
                    tag: "component",
                    on: { "form:sent": _vm.sent, "form:error": _vm.error },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSent
        ? _c("IcFormsSent", { attrs: { data: _vm.sentData } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }